export default __webpack_public_path__ + "static/media/about-page-carousel.6c38c396.png";